// import Swiper and modules styles from npm
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Thumbs, FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


function loadSwiperCarousel(carouselID, args) { 

    const carouselElement = '#' + carouselID; //prefix the ID with # to target the element in the DOM

    //Presets 

    let isAutoplayFeature = false;
    let isSlidesPerView = args.perViewNumber
    let isMobileSlidesPerView = args.perMobileViewNumber
    let isCentredSlide = true

    if (args.carouselType.includes('logo-row')) {
        
        isCentredSlide = false
    }

    if (Boolean(args.carouselAutoplay)) {
        
        isAutoplayFeature = true, {

            delay: args.carouselAutoplayInterval
        }
    }

    if (args.perViewNumber.includes('auto')) {
        isSlidesPerView = 'auto'  
    }

    if (args.perMobileViewNumber.includes('auto')) {
        isMobileSlidesPerView = 'auto'  
    }

    if (args.carouselType.includes('fixed-width-cards')) {
        
        isSlidesPerView = 'auto'
        isMobileSlidesPerView = 'auto'
    }

    console.log('is autoPlay', isAutoplayFeature)

    const options = {

        modules: [Navigation, Pagination, Scrollbar, Thumbs, FreeMode, Autoplay],

        // If we need pagination
        pagination: {
            el: '.swiper-pagination-'+carouselID,
            type: 'bullets',
            clickable: true,
            dynamicBullets: true, // Enables dynamic pagination
            dynamicMainBullets: 3
        },

        // Navigation arrows
        navigation: {
            nextEl: '.carousel__arrow--right-'+carouselID, //target the specific carousel using the unique ID
            prevEl: '.carousel__arrow--left-'+carouselID,
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',

        },
        grabCursor: true,
        keyboard: {
            enabled: true,
        },

        //Responsive
        centeredSlides: isCentredSlide, //only for mobile
        slidesPerView: isMobileSlidesPerView,
        // freeMode: {
        //     enabled: true,
        //     sticky: true,
        // },
        breakpoints: {
            600: { //upwards of 600
                slidesPerView: isSlidesPerView, //<-- if the perViewNumber is greater than 1
                centeredSlides: false,
                freeMode: false
            },
        },

        // Optional parameters
        //loop: true,

        spaceBetween: args.carouselSlideGapPx,

        // thumbs: {
        //     swiper: thumbSwiper //init thumb slider however this is really flakey and does not work. Using thumbnailGalleryNavigation() instead
        // },
        
        autoplay: isAutoplayFeature

    }

    // init Swiper:
    const swiper = new Swiper(carouselElement, options);

    thumbnailGalleryNavigation(swiper, carouselElement)

}

function thumbnailGalleryNavigation(swiper, carouselElement) {

    const getGalleryThumbs = document.querySelectorAll('.carousel-custom-thumbnails__item')
    let thumbActive;

    for (const thumb of getGalleryThumbs) {

        thumb.addEventListener('click', (event) => {

            const thumbCurrent = event.target.parentElement //not image but parent container
            const thumbIndex = event.target.parentElement.dataset.thumbnailCount
            const thumbCurrentGroupContainerID = thumbCurrent.parentElement.dataset.carouselId

            if (thumbActive) { thumbActive.classList.remove('is-active') } //sweep and remove
            
            thumbCurrent.classList.add('is-active') //add 

            // Target correct swiper 
            // Retrieve the specific instance attached to the DOM element ID make sure that the IDs match up
            const targetSwiper = document.querySelector('#' + thumbCurrentGroupContainerID).swiper; //<-- can be grabbed like this

            targetSwiper.slideTo(thumbIndex, 500) //update swiper using .slideTo() API

            thumbActive = event.currentTarget //set 
        })

    }
}


//init 

function initialiseCarouselGetValues() {
    
    const allCarousels = document.querySelectorAll('.carousel');

    for (const carousel of allCarousels) {

        const carouselID = carousel.id
        console.log(carousel.id, 'carousel.dataset.carouselAutoplay',carousel.dataset.carouselAutoplay)
        const args = {
            carouselType: carousel.dataset.carouselType,
            carouselAutoplay: Boolean(carousel.dataset.carouselAutoplay),
            carouselAutoplayInterval: carousel.dataset.carouselAutoplayInterval,
            perViewNumber: carousel.dataset.carouselSlidesPerView,
            perMobileViewNumber: carousel.dataset.carouselSlidesPerViewMobile,
            startAtNumber: carousel.dataset.carouselSlideNumberStart,
            carouselSlideGapPx: carousel.dataset.carouselSlideGapPx
        }

        loadSwiperCarousel(carouselID, args)
    
    }
}

document.addEventListener("DOMContentLoaded", () => {

    initialiseCarouselGetValues()

    //awaiting the block editor before loading 
    if(window._wpLoadBlockEditor){

        window._wpLoadBlockEditor.then( function() {

            setTimeout(() => {

                initialiseCarouselGetValues()       
                
            },1000)

        });
    }
})